import { useState } from "react";
import { Wand2 } from "lucide-react";
import { toast } from "sonner";

/* Bulk shipping markup for the picked service + country: cost + % or + ₹ on every weight slab (rounded up to ₹1).
   "Fill empty only" keeps prices already set; "Overwrite all" replaces them. Partner still presses Save. */
export const ShipMarkup = ({ weights, rows, setRows }) => {
  const [mode, setMode] = useState("percent");
  const [val, setVal] = useState("20");
  const [scope, setScope] = useState("empty");
  const withCost = (weights || []).filter((w) => w.cost != null);
  if (!withCost.length) return null;
  const apply = () => {
    const v = Number(val);
    if (!(v >= 0)) return toast.error("Write a markup of 0 or more");
    const key = (x) => `${x.service}|${x.country}|${x.w_from ?? ""}|${x.w_to ?? ""}`;
    const have = Object.fromEntries(rows.map((r, i) => [key(r), i]));
    const next = [...rows];
    let set = 0, kept = 0;
    withCost.forEach((w) => {
      const sale = Math.max(1, Math.ceil(Math.round((mode === "percent" ? w.cost * (1 + v / 100) : w.cost + v) * 100) / 100));
      const i = have[key(w)];
      if (i === undefined) { next.unshift({ service: w.service, country: w.country, weight: w.weight, w_from: w.w_from, w_to: w.w_to, sale }); set += 1; }
      else if (scope === "all" || !(Number(next[i].sale) > 0)) { next[i] = { ...next[i], sale }; set += 1; }
      else kept += 1;
    });
    setRows(next.sort((a, b) => a.service.localeCompare(b.service) || a.country.localeCompare(b.country) || (a.w_from ?? 0) - (b.w_from ?? 0)));
    toast.success(`${set} shipping price(s) filled${kept ? `, ${kept} kept` : ""} — press Save shipping prices`);
  };
  const box = "h-7 rounded border px-1.5 text-[11px]";
  return (
    <div className="flex w-full flex-wrap items-center gap-1.5 border-t border-dashed pt-1.5 text-[11px]" data-testid="ds-ship-markup">
      <Wand2 className="h-3.5 w-3.5 text-teal-700" /><b>Bulk markup</b> cost +
      <input type="number" min="0" value={val} onChange={(e) => setVal(e.target.value)} className={`${box} w-16`} data-testid="ds-ship-markup-value" />
      <select value={mode} onChange={(e) => setMode(e.target.value)} className={box} data-testid="ds-ship-markup-mode"><option value="percent">%</option><option value="fixed">₹</option></select>
      <select value={scope} onChange={(e) => setScope(e.target.value)} className={box} data-testid="ds-ship-markup-scope">
        <option value="empty">Fill empty only</option><option value="all">Overwrite all</option></select>
      <button onClick={apply} className="rounded bg-teal-600 px-2 py-1 font-semibold text-white" data-testid="ds-ship-markup-apply">Apply to {withCost.length} slab(s)</button>
    </div>
  );
};
